import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["postalCode", "street", "neighborhood", "stateSelect", "citySelect"]

  async lookup() {
    const cep = this.postalCodeTarget.value.replace(/\D/g, "")

    // Masked value is "00000-000" (9 chars), raw digits must be 8
    if (cep.length !== 8) return

    try {
      const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${cep}`)

      if (!response.ok) return

      const data = await response.json()

      this.streetTarget.value = data.street || ""
      this.neighborhoodTarget.value = data.neighborhood || ""

      if (data.state && data.city) {
        get("/cities/lookup", {
          query: {
            state_abbreviation: data.state,
            city_name: data.city,
            state_select: this.stateSelectTarget.id,
            city_select: this.citySelectTarget.id
          },
          responseKind: "turbo-stream"
        })
      }
    } catch {
      // Silently ignore network errors
    }
  }
}
